import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Otto } from '../components/otto';

// Internal-product 404. Gated at the route level in App.js so this
// only renders for signed-in admins — supplier routes and the
// signed-out tree fall back to the default route. Layout matches the
// Turbo 404 mock: a faint giant "404" watermark behind a centred
// content stack with Turbo, eyebrow, headline, body, and the two
// back-on-track actions.
export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-canvas flex items-center justify-center px-10 py-20 relative overflow-hidden">

      {/* Watermark — a single huge "404" behind the content, low
          enough opacity that it reads as a background tone rather
          than copy. pointer-events:none keeps it out of the click
          target, user-select:none stops it being selected with the
          headline. */}
      <div
        aria-hidden="true"
        className="absolute inset-0 flex items-center justify-center pointer-events-none select-none"
        style={{
          fontFamily: 'Metropolis',
          fontSize: '380px',
          fontWeight: 800,
          color: 'rgba(146, 212, 0, 0.04)',
          letterSpacing: '-0.05em',
          lineHeight: 1,
        }}>
        404
      </div>

      {/* Content stack — sits above the watermark via z-10 and is
          centred both axes by the outer flex. max-width caps the
          headline so the line break stays graceful on wide screens. */}
      <div className="relative z-10 flex flex-col items-center text-center max-w-[620px]">
        <div className="mb-7">
          <Otto pose="searching" size={132} ariaLabel="Otto, searching for the page" />
        </div>
        <p className="font-['Metropolis'] text-[11px] font-extrabold tracking-[0.3em] uppercase text-fusion-forest mb-3.5">Wrong Turn</p>
        <h1 className="font-['Metropolis'] text-4xl font-extrabold text-ink leading-tight mb-3.5">Otto can't spot that page.</h1>
        <p className="font-['Metropolis'] text-[15px] text-fusion-mid-grey leading-relaxed max-w-[540px] mb-8">
          This page must have taken a detour. Let's get you back on track — either head home or pop back to where you were.
        </p>
        <div className="flex items-center gap-3 flex-wrap justify-center">
          <button
            onClick={() => navigate('/dashboard')}
            className="bg-[#92D400] text-[#131313] border border-[#92D400] rounded px-[22px] py-3 font-['Metropolis'] text-xs font-bold tracking-[0.18em] uppercase inline-flex items-center gap-2 hover:bg-[#a4e810] transition-colors cursor-pointer">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M3 12L12 3l9 9" />
              <path d="M5 10v10a1 1 0 001 1h12a1 1 0 001-1V10" />
            </svg>
            Back to Dashboard
          </button>
          {/* Go back uses history rather than a fixed route so the
              user lands wherever they came from. If they arrived via
              a direct URL with no history, navigate(-1) is a no-op
              and they stay on the 404 — that's OK, the primary
              action will still take them home. */}
          <button
            onClick={() => navigate(-1)}
            className="bg-transparent text-ink border border-line rounded px-[22px] py-3 font-['Metropolis'] text-xs font-bold tracking-[0.18em] uppercase hover:border-[#DADCCD] transition-colors cursor-pointer">
            ← Go back
          </button>
        </div>
      </div>
    </div>
  );
}
